import React, { useMemo, useRef, useState, useEffect } from "react";
import classes from "./WhatsIncluded.module.css";
import { Container, Row, Col } from "react-bootstrap";
import PageLayout from "../../PageLayout/PageLayout";
import Fonts from "../../../../../stories/assets/Fonts";
import Colors from "../../../../../stories/assets/Colors";
import { Tabs } from "../../../../../stories/Tabs/Tabs";
import { LinkButtonWithIcon } from "../../../../../stories/LinkButtonWithIcon/LinkButtonWithIcon";
import { Checkbox } from "../../../../../stories/Checkbox/Checkbox";
import AddEquipmentModal from "../../../../../components/Modals/CoachFlow/OnBoarding/AddEquipment/AddEquipment";
import {
  AddIconBlue,
  equipicon,
  accessoriesicon,
  apparelicon,
  EquipmentIcon,
  ApparelIcon,
  AccessoriesIcon,
} from "../../../../../constant/imagePath";
import { Button } from "../../../../../stories/Button/Button";
import { isMobileViewHook } from "../../../../../CustomHooks/isMobileViewHook";
import WhatsIncludedMobile from "./WhatsIncludedMobile";
import { useSelector, useDispatch } from "react-redux";
import { setPersonalData } from "../../../../../store/Actions/authAction";

const WhatsIncludedDesktop = () => {
  const dispatch = useDispatch();
  const getDataFromRedux = useSelector(
    (state) => state?.onBoardingReducer?.setLesson
  );

  const [tabs, setTabs] = useState({ label: "Provide", value: 4 });
  const [showEquipmentModal, setShowEquipmentModal] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalData, setModalData] = useState([]);

  //  Provide states
  const [renderEquipments, setRenderEquipments] = useState(
    getDataFromRedux?.provide
      ? getDataFromRedux?.provide?.renderEquipments
      : [
          { label: "Grips", value: "Grips", isChecked: "" },
          { label: "Racquet string", value: "Racquet string", isChecked: "" },
          { label: "Tennis racquet", value: "Tennis racquet", isChecked: "" },
          { label: "Tennis Balls", value: "Tennis Balls", isChecked: "" },
        ]
  );
  const [renderApparels, setRenderApparels] = useState(
    getDataFromRedux?.provide
      ? getDataFromRedux?.provide?.renderApparels
      : [
          { label: "Tennis shoes", value: "Tennis shoes", isChecked: "" },
          { label: "Sweatbands", value: "Sweatbands", isChecked: "" },
          { label: "Practice skirt", value: "Practice skirt", isChecked: "" },
          { label: "Racquet bag", value: "Racquet bag", isChecked: "" },
          { label: "Practice shirts", value: "Practice shirts", isChecked: "" },
          { label: "Hat/Visor", value: "Hat/Visor", isChecked: "" },
        ]
  );
  const [renderAccessories, setRenderAccessories] = useState(
    getDataFromRedux?.provide
      ? getDataFromRedux?.provide?.renderAccessories
      : [
          { label: "Water", value: "Water", isChecked: "" },
          { label: "Sunglasses", value: "Sunglasses", isChecked: "" },
          {
            label: "Hair ties/Headband",
            value: "Hair ties/Headband",
            isChecked: "",
          },
          { label: "Athletic tape", value: "Athletic tape", isChecked: "" },
          { label: "Sunscreen", value: "Sunscreen", isChecked: "" },
        ]
  );
  //  Bring states
  const [renderEquipmentsForBring, setRenderEquipmentsForBring] = useState(
    getDataFromRedux?.bring
      ? getDataFromRedux?.bring?.renderEquipmentsForBring
      : [
          { label: "Grips", value: "Grips", isChecked: "" },
          { label: "Racquet string", value: "Racquet string", isChecked: "" },
          { label: "Tennis racquet", value: "Tennis racquet", isChecked: "" },
          { label: "Tennis Balls", value: "Tennis Balls", isChecked: "" },
        ]
  );
  const [renderApparelsForBring, setRenderApparelsForBring] = useState(
    getDataFromRedux?.bring
      ? getDataFromRedux?.bring?.renderApparelsForBring
      : [
          { label: "Tennis shoes", value: "Tennis shoes", isChecked: "" },
          { label: "Sweatbands", value: "Sweatbands", isChecked: "" },
          { label: "Practice skirt", value: "Practice skirt", isChecked: "" },
          { label: "Racquet bag", value: "Racquet bag", isChecked: "" },
          { label: "Practice shirts", value: "Practice shirts", isChecked: "" },
          { label: "Hat/Visor", value: "Hat/Visor", isChecked: "" },
        ]
  );
  const [renderAccessoriesForBring, setRenderAccessoriesForBring] = useState(
    getDataFromRedux?.bring
      ? getDataFromRedux?.bring?.renderAccessoriesForBring
      : [
          { label: "Water", value: "Water", isChecked: "" },
          { label: "Sunglasses", value: "Sunglasses", isChecked: "" },
          {
            label: "Hair ties/Headband",
            value: "Hair ties/Headband",
            isChecked: "",
          },
          { label: "Athletic tape", value: "Athletic tape", isChecked: "" },
          { label: "Sunscreen", value: "Sunscreen", isChecked: "" },
        ]
  );

  // /

  function onAdd() {
    if (tabs?.label == "Provide") {
      if ("Equipment" === modalTitle) {
        const newArr = [...modalData];
        setRenderEquipments(newArr);
      }
      if ("Apparel" === modalTitle) {
        const newArr = [...modalData];
        setRenderApparels(newArr);
      }
      if ("Accessories" === modalTitle) {
        const newArr = [...modalData];
        setRenderAccessories(newArr);
      }
    } else {
      if ("Equipment" === modalTitle) {
        const newArr = [...modalData];
        setRenderEquipmentsForBring(newArr);
      }
      if ("Apparel" === modalTitle) {
        const newArr = [...modalData];
        setRenderApparelsForBring(newArr);
      }
      if ("Accessories" === modalTitle) {
        const newArr = [...modalData];
        setRenderAccessoriesForBring(newArr);
      }
    }
  }
  useEffect(() => {
    if (tabs?.label == "Provide") {
      if ("Equipment" === modalTitle) {
        const newArr = [...renderEquipments];
        setModalData(newArr);
      }
      if ("Apparel" === modalTitle) {
        const newArr = [...renderApparels];
        setModalData(newArr);
      }
      if ("Accessories" === modalTitle) {
        const newArr = [...renderAccessories];
        setModalData(newArr);
      }
    } else {
      if ("Equipment" === modalTitle) {
        const newArr = [...renderEquipmentsForBring];
        setModalData(newArr);
      }
      if ("Apparel" === modalTitle) {
        const newArr = [...renderApparelsForBring];
        setModalData(newArr);
      }
      if ("Accessories" === modalTitle) {
        const newArr = [...renderAccessoriesForBring];
        setModalData(newArr);
      }
    }
  }, [showEquipmentModal]);

  const tabsdata = [
    { label: "Provide", value: 4 },
    { label: "What To Bring", value: "0" },
  ];

  function saveDataIntoRedux() {
    dispatch(
      setPersonalData("set-lesson", {
        ...getDataFromRedux,
        provide: { renderEquipments, renderApparels, renderAccessories },
        bring: {
          renderEquipmentsForBring,
          renderApparelsForBring,
          renderAccessoriesForBring,
        },
      })
    );
  }

  // Render Tabs Component
  const ProvideTab = () => (
    <div>
      <h4
        style={{
          ...Fonts.h4,
          color: Colors.neutralShadesOfNero,
          fontSize: "26px",
        }}
        className={[classes.mt32, classes.mb8].join(" ")}
      >
        What will you provide?
      </h4>
      <p
        style={{ ...Fonts.p1, color: Colors.neutralShadesOfDimGray }}
        className={[classes.mb52].join(" ")}
      >
        Select the things you can provide for your future students.
      </p>

      <Row className={["g-0", classes.mt52].join(" ")}>
        <Col md={12} className={classes.mb52}>
          <div
            className={`${[classes.headingWithAddItem].join(" ")}`}
            style={{
              borderBottom: `1px solid ${Colors.neutralShadesOfWhisper}`,
            }}
          >
            <div className={`${[classes.headingWithIcon].join(" ")}`}>
              <img src={EquipmentIcon} />
              <span
                style={{
                  ...Fonts.h7,
                  lineHeight: "24px",
                  fontFamily: "inter-600",
                  color: Colors.neutralShadesOfNero,
                }}
              >
                Equipment
              </span>
            </div>
            {/* Right Side */}
            <LinkButtonWithIcon
              text={"Add item"}
              leftIcon={AddIconBlue}
              primary={true}
              customStyle={{
                ...Fonts.b2,
                lineHeight: "20px",
              }}
              iconStyle={{
                marginRight: "4px",
                width: "16px",
                height: "16px",
              }}
              onClick={() => {
                setModalTitle("Equipment");
                setShowEquipmentModal(true);
              }}
            />
          </div>
          <Col md={12}>
            <Row>
              {renderEquipments?.map((item, i) => {
                return (
                  <Col md={6}>
                    <Checkbox
                      label={item?.label}
                      checked={item?.label == item?.isChecked}
                      onClick={(e) => {
                        const newArr = [...renderEquipments];

                        if (newArr[i].isChecked !== item?.label) {
                          newArr[i].isChecked = item?.label;
                        } else {
                          newArr[i].isChecked = "";
                        }
                        setRenderEquipments(newArr);
                      }}
                    />
                  </Col>
                );
              })}
            </Row>
          </Col>
        </Col>
        <Col md={12} className={classes.mb52}>
          <div
            className={`${[classes.headingWithAddItem].join(" ")}`}
            style={{
              borderBottom: `1px solid ${Colors.neutralShadesOfWhisper}`,
            }}
          >
            <div className={`${[classes.headingWithIcon].join(" ")}`}>
              <img src={ApparelIcon} />
              <span
                style={{
                  ...Fonts.h7,
                  lineHeight: "24px",
                  fontFamily: "inter-600",
                  color: Colors.neutralShadesOfNero,
                }}
              >
                Apparel
              </span>
            </div>
            {/* Right Side */}
            <LinkButtonWithIcon
              text={"Add item"}
              leftIcon={AddIconBlue}
              primary={true}
              customStyle={{
                ...Fonts.b2,
                lineHeight: "20px",
              }}
              iconStyle={{
                marginRight: "4px",
                width: "16px",
                height: "16px",
              }}
              onClick={() => {
                setModalTitle("Apparel");
                setShowEquipmentModal(true);
              }}
            />
          </div>
          <Col md={12}>
            <Row>
              {renderApparels?.map((item, i) => {
                return (
                  <Col md={6}>
                    <Checkbox
                      label={item.label}
                      checked={item?.label == item?.isChecked}
                      onClick={(e) => {
                        const newArr = [...renderApparels];
                        if (newArr[i].isChecked !== item?.label) {
                          newArr[i].isChecked = item?.label;
                        } else {
                          newArr[i].isChecked = "";
                        }
                        setRenderApparels(newArr);
                      }}
                    />
                  </Col>
                );
              })}
            </Row>
          </Col>
        </Col>
        <Col md={12} className={classes.mb52}>
          <div
            className={`${[classes.headingWithAddItem].join(" ")}`}
            style={{
              borderBottom: `1px solid ${Colors.neutralShadesOfWhisper}`,
            }}
          >
            <div className={`${[classes.headingWithIcon].join(" ")}`}>
              <img src={AccessoriesIcon} />
              <span
                style={{
                  ...Fonts.h7,
                  lineHeight: "24px",
                  fontFamily: "inter-600",
                  color: Colors.neutralShadesOfNero,
                }}
              >
                Accessories
              </span>
            </div>
            {/* Right Side */}
            <LinkButtonWithIcon
              text={"Add item"}
              leftIcon={AddIconBlue}
              primary={true}
              customStyle={{
                ...Fonts.b2,
                lineHeight: "20px",
              }}
              iconStyle={{
                marginRight: "4px",
                width: "16px",
                height: "16px",
              }}
              onClick={() => {
                setModalTitle("Accessories");
                setShowEquipmentModal(true);
              }}
            />
          </div>
          <Col md={12}>
            <Row>
              {renderAccessories?.map((item, i) => {
                return (
                  <Col md={6}>
                    <Checkbox
                      label={item.label}
                      checked={item?.label == item?.isChecked}
                      onClick={(e) => {
                        const newArr = [...renderAccessories];
                        if (newArr[i].isChecked !== item?.label) {
                          newArr[i].isChecked = item?.label;
                        } else {
                          newArr[i].isChecked = "";
                        }
                        setRenderAccessories(newArr);
                      }}
                    />
                  </Col>
                );
              })}
            </Row>
          </Col>
        </Col>
      </Row>
    </div>
  );

  const WhattobringTab = () => (
    <div>
      <h4
        style={{
          ...Fonts.h4,
          color: Colors.neutralShadesOfNero,
          fontSize: "26px",
        }}
        className={[classes.mt32, classes.mb8].join(" ")}
      >
        What student should bring?
      </h4>
      <p
        style={{ ...Fonts.p1, color: Colors.neutralShadesOfDimGray }}
        className={[classes.mb52].join(" ")}
      >
        Select the things that the student should take to your lesson.
      </p>
      <Row className={["g-0", classes.mt52].join(" ")}>
        <Col md={12} className={classes.mb52}>
          <div
            className={`${[classes.headingWithAddItem].join(" ")}`}
            style={{
              borderBottom: `1px solid ${Colors.neutralShadesOfWhisper}`,
            }}
          >
            <div className={`${[classes.headingWithIcon].join(" ")}`}>
              <img src={EquipmentIcon} />
              <span
                style={{
                  ...Fonts.h7,
                  lineHeight: "24px",
                  fontFamily: "inter-600",
                  color: Colors.neutralShadesOfNero,
                }}
              >
                Equipment
              </span>
            </div>
            {/* Right Side */}
            <LinkButtonWithIcon
              text={"Add item"}
              leftIcon={AddIconBlue}
              primary={true}
              customStyle={{
                ...Fonts.b2,
                lineHeight: "20px",
              }}
              iconStyle={{
                marginRight: "4px",
                width: "16px",
                height: "16px",
              }}
              onClick={() => {
                setModalTitle("Equipment");
                setShowEquipmentModal(true);
              }}
            />
          </div>
          <Col md={12}>
            <Row>
              {renderEquipmentsForBring?.map((item, i) => {
                return (
                  <Col md={6}>
                    <Checkbox
                      label={item?.label}
                      checked={item?.label == item?.isChecked}
                      onClick={(e) => {
                        const newArr = [...renderEquipments];

                        if (newArr[i].isChecked !== item?.label) {
                          newArr[i].isChecked = item?.label;
                        } else {
                          newArr[i].isChecked = "";
                        }
                        setRenderEquipmentsForBring(newArr);
                      }}
                    />
                  </Col>
                );
              })}
            </Row>
          </Col>
        </Col>
        <Col md={12} className={classes.mb52}>
          <div
            className={`${[classes.headingWithAddItem].join(" ")}`}
            style={{
              borderBottom: `1px solid ${Colors.neutralShadesOfWhisper}`,
            }}
          >
            <div className={`${[classes.headingWithIcon].join(" ")}`}>
              <img src={ApparelIcon} />
              <span
                style={{
                  ...Fonts.h7,
                  lineHeight: "24px",
                  fontFamily: "inter-600",
                  color: Colors.neutralShadesOfNero,
                }}
              >
                Apparel
              </span>
            </div>
            {/* Right Side */}
            <LinkButtonWithIcon
              text={"Add item"}
              leftIcon={AddIconBlue}
              primary={true}
              customStyle={{
                ...Fonts.b2,
                lineHeight: "20px",
              }}
              iconStyle={{
                marginRight: "4px",
                width: "16px",
                height: "16px",
              }}
              onClick={() => {
                setModalTitle("Apparel");
                setShowEquipmentModal(true);
              }}
            />
          </div>
          <Col md={12}>
            <Row>
              {renderApparelsForBring?.map((item, i) => {
                return (
                  <Col md={6}>
                    <Checkbox
                      label={item.label}
                      checked={item?.label == item?.isChecked}
                      onClick={(e) => {
                        const newArr = [...renderApparels];
                        if (newArr[i].isChecked !== item?.label) {
                          newArr[i].isChecked = item?.label;
                        } else {
                          newArr[i].isChecked = "";
                        }
                        setRenderApparelsForBring(newArr);
                      }}
                    />
                  </Col>
                );
              })}
            </Row>
          </Col>
        </Col>
        <Col md={12} className={classes.mb52}>
          <div
            className={`${[classes.headingWithAddItem].join(" ")}`}
            style={{
              borderBottom: `1px solid ${Colors.neutralShadesOfWhisper}`,
            }}
          >
            <div className={`${[classes.headingWithIcon].join(" ")}`}>
              <img src={AccessoriesIcon} />
              <span
                style={{
                  ...Fonts.h7,
                  lineHeight: "24px",
                  fontFamily: "inter-600",
                  color: Colors.neutralShadesOfNero,
                }}
              >
                Accessories
              </span>
            </div>
            {/* Right Side */}
            <LinkButtonWithIcon
              text={"Add item"}
              leftIcon={AddIconBlue}
              primary={true}
              customStyle={{
                ...Fonts.b2,
                lineHeight: "20px",
              }}
              iconStyle={{
                marginRight: "4px",
                width: "16px",
                height: "16px",
              }}
              onClick={() => {
                setModalTitle("Accessories");
                setShowEquipmentModal(true);
              }}
            />
          </div>
          <Col md={12}>
            <Row>
              {renderAccessoriesForBring?.map((item, i) => {
                return (
                  <Col md={6}>
                    <Checkbox
                      label={item.label}
                      checked={item?.label == item?.isChecked}
                      onClick={(e) => {
                        const newArr = [...renderAccessoriesForBring];
                        if (newArr[i].isChecked !== item?.label) {
                          newArr[i].isChecked = item?.label;
                        } else {
                          newArr[i].isChecked = "";
                        }
                        setRenderAccessoriesForBring(newArr);
                      }}
                    />
                  </Col>
                );
              })}
            </Row>
          </Col>
        </Col>
      </Row>
    </div>
  );

  return (
    <div className={[classes.WhatsincludedScreen].join(" ")}>
      <Container fluid className={[classes.container, "p-0"].join(" ")}>
        <Row className={[classes.mb52, "g-0"].join(" ")}>
          <Col md={12}>
            <div className={`${classes.edit_heading_main_div}`}>
              <div>
                <h3
                  style={{
                    ...Fonts.h3,
                    color: Colors.neutralShadesOfNero,
                  }}
                >
                  Edit Lesson Info
                </h3>
              </div>
              <div className={`${classes.edit_heading_button_div}`}>
                <Button
                  primary={false}
                  size="Medium"
                  customStyle={{
                    padding: "14px 24px",
                    width: "max-content",
                    marginRight: "12px",
                    ...Fonts.b2,
                  }}
                >
                  Profile preview
                </Button>
                <Button
                  primary={true}
                  size="Medium"
                  customStyle={{
                    padding: "14px 24px",
                    width: "max-content",
                    ...Fonts.b2,
                  }}
                  onClick={saveDataIntoRedux}
                >
                  Save changes
                </Button>
              </div>
            </div>
          </Col>
        </Row>

        <Row className={`g-0 ${[classes.row].join(" ")}`}>
          <Col md={12}>
            <Tabs tabsData={tabsdata} state={tabs} setState={setTabs} />
          </Col>

          <Col md={12}>
            {tabs.label === "Provide" && <ProvideTab />}
            {tabs.label === "What To Bring" && <WhattobringTab />}
          </Col>
        </Row>
      </Container>
      {/* Add Equipment Modal */}
      <AddEquipmentModal
        show={showEquipmentModal}
        setShow={setShowEquipmentModal}
        title={modalTitle}
        state={modalData}
        setter={setModalData}
        onAdd={onAdd}
        options={["avbc", "cass"]}
      />
    </div>
  );
};

const WhatsIncluded = () => {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    isMobileViewHook(setIsMobile, 992);
  }, []);
  return isMobile ? <WhatsIncludedMobile /> : <WhatsIncludedDesktop />;
};
export default WhatsIncluded;
